// Renamed article URLs — old slug -> new slug.
// Keep in sync with SLUG_REDIRECTS in backend/seo_render.py.
export const POST_REDIRECTS = {
  "when-and-how-should-i-transition-my-baby-from-formula-or-breast-milk-to-cows-mil":
    "when-and-how-should-i-transition-my-baby-from-formula-or-breast-milk-to-cows-milk",
  "do-wearable-or-hands-free-breast-pumps-actually-work-as-well-as-traditional-pump":
    "do-wearable-or-hands-free-breast-pumps-actually-work-as-well-as-traditional-pumps",
  "i-have-a-white-spot-or-blister-on-my-nipple-is-it-dangerous-and-how-do-i-treat-i":
    "i-have-a-white-spot-or-blister-on-my-nipple-is-it-dangerous-and-how-do-i-treat-it",
};
